// extracted by mini-css-extract-plugin
export default {"input":"LabeledInput_input__3rhKN"};